import axios from 'axios'
import runtimeConfig from './runtime-config'

const getBearerToken = async ({ code }) => {
  try {
    const res = await axios.post(
      `${runtimeConfig('public_web_front_end_auth_url')}/auth/heroku-dhc/token`,
      {
        code,
        grant_type: 'authorization_code'
      }
    )
    return res.data
  } catch (e) {
    throw new Error('Failed to get token from Front End Auth')
  }
}

export default getBearerToken
